import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import OptionsLandschaftGroupViewModel from '@/ViewModels/Controls/OptionsLandschaftGroupViewModel';
import LabelType from '@/Controls/Label';

export default class OptionsLandschaftGroup extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private label: LabelType;
    private control: JQuery;
    public context: OptionsLandschaftGroupViewModel;

    public constructor(private viewModel: OptionsLandschaftGroupViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated((widget) => {
            this.applyBindings(this.control, {
                controlName: 'optionslandschaftgroup',

                loader: this.context.isBusy,

                controlIdent: this.identifier,

                tooltip: this.context.tooltip,

                invalid: this.context.invalidationText,

                visible: this.context.isVisible
            });

            if (this.context.label != null)
            {
                this.label = new this.Label(this.context.label);
                let tuple = this.label.getTuple();

                tuple.control.appendTo(this.control);
            }

            this.applyBindings(this.control, {
                optionsLandschaftGroupLinks: {
                    parent: this,

                    links: this.context.links
                }
            });
        });
    }

    public getControl(): JQuery {
        if (this.control != null) {
            return this.control;
        }

        this.control = this.element || $('<div>');
        this.widget(null);

        return this.control;
    }
}

ComponentManager.setControl('OptionsLandschaftGroup', OptionsLandschaftGroup, 'RADPresentation.HTMLClient.DefaultViewExtensions');